import { ProductCard, type ProductCardData } from "./product-card";
import { PeptideProductCard, type PeptideProductCardData } from "@/ui/components/peptide";

type ProductOrPeptideCard = ProductCardData | PeptideProductCardData;

function isPeptideCard(product: ProductOrPeptideCard): product is PeptideProductCardData {
	return "peptideMetadata" in product && product.peptideMetadata != null;
}

interface ProductGridProps {
	products: ProductOrPeptideCard[];
}

export function ProductGrid({ products }: ProductGridProps) {
	return (
		<div className="grid w-full grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3 lg:gap-5">
			{products.map((product, index) => (
				<div
					key={product.id}
					className="animate-fade-in-up opacity-0"
					style={{ animationDelay: `${Math.min(index * 50, 400)}ms` }}
				>
					{isPeptideCard(product) ? (
						<PeptideProductCard product={product} priority={index < 4} />
					) : (
						<ProductCard product={product} priority={index < 4} />
					)}
				</div>
			))}
		</div>
	);
}
